<template>
  <div class="table-cell-copy-id">
    <span class="copy-id-value">{{ displayValue }}</span>
    <button
      v-if="hasValue"
      type="button"
      class="button is-small is-light ml-1 copy-id-button"
      :title="buttonTitle"
      :aria-label="buttonTitle"
      @click.stop="copyId"
    >
      <span class="icon is-small"><i class="fas fa-copy"></i></span>
    </button>
  </div>
</template>
<script>
// Table cell that shows an id (applicant / position / offer) with a one-click
// copy button. Copies via the async clipboard API and falls back to the
// execCommand helper ($utils.copyToClipboard) when it is missing or rejects.
export default {
  name: 'TableCellCopyId',
  props: {
    payload: {
      type: [String, Number],
      default: null
    },
    additional_data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasValue () {
      return this.payload !== null && this.payload !== undefined && String(this.payload).trim() !== ''
    },
    displayValue () {
      return this.hasValue ? String(this.payload) : ''
    },
    buttonTitle () {
      return (this.additional_data && this.additional_data.title) || 'העתק מזהה'
    }
  },
  methods: {
    async copyId () {
      if (!this.hasValue) {
        return
      }
      const text = String(this.payload).trim()
      let copied = false
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text)
          copied = true
        }
      } catch (err) {
        copied = false
      }
      if (!copied) {
        try {
          copied = this.$utils.copyToClipboard(text) !== false
        } catch (fallbackErr) {
          copied = false
        }
      }
      if (!copied) {
        this.$utils.emit('show_toast', { text: 'שגיאה בהעתקה', type: 'error' })
        return
      }
      this.$utils.emit('show_toast', { text: 'הועתק', type: 'success', duration: 2000 })
    }
  }
}
</script>
<style scoped>
.table-cell-copy-id {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
</style>
